function getPopperPropsFromShorthand(value) {
  if (typeof value === 'object' && value !== null) {
    return value.popper;
  }

  return undefined;
}

export default getPopperPropsFromShorthand;
//# sourceMappingURL=getPopperPropsFromShorthand.js.map
